import Navbar from './components/Navbar';
import Hero from './components/Hero';
import DailyPicks from './components/DailyPicks';
import HotRanking from './components/HotRanking';
import Booklists from './components/Booklists';
import Categories from './components/Categories';
import About from './components/About';
import Faq from './components/Faq';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-950">
      <Navbar />
      <main>
        <Hero />
        <DailyPicks />
        <HotRanking />
        <Booklists />
        <Categories />
        <About />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}